import MyAddressesHOC from 'HOC/myAddressesHOC';
import MyAddresses from '../components/MyAddresses';

export default MyAddressesHOC(MyAddresses);
